"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveMembers = void 0;
/**
 * Save member in storage
 *
 * @alpha
 * @typeParam T The type of the repository that should be derived from {@link IMembersRepository}
 * @param repository The repository instance to handle members. See {@link membersRepository}
 * @param members A list of members to store
 *
 * @example
 * ```ts
 * saveMembers(memberRepository, members);
 * ```
 */
function saveMembers(repository, members) {
    repository.saveMembers(members);
}
exports.saveMembers = saveMembers;
//# sourceMappingURL=save-members.js.map